var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.508 14.5628V27.3128M15.508 14.5628L11.9664 17.3961M15.508 14.5628L19.0497 17.3961M5.63952 10.4785C4.29965 10.8157 3.12902 11.6305 2.34755 12.7699C1.56608 13.9093 1.22757 15.2948 1.39562 16.6662C1.56368 18.0376 2.22672 19.3004 3.26018 20.2174C4.29364 21.1344 5.62639 21.6424 7.00802 21.6461H8.42469",
    stroke: "#19C489",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9341 7.67492C20.4499 5.75756 19.2547 4.09605 17.5909 3.0272C15.9271 1.95835 13.9191 1.56213 11.974 1.91887C10.0289 2.2756 8.29222 3.3586 7.116 4.94831C5.93977 6.53803 5.41203 8.51552 5.63974 10.4799C5.63974 10.4799 5.85649 11.7294 6.29991 12.4378",
    stroke: "#19C489",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5915 21.6452C23.5917 21.6445 24.5804 21.432 25.4926 21.0216C26.4048 20.6113 27.2197 20.0124 27.8837 19.2644C28.5478 18.5164 29.0459 17.6363 29.3453 16.6819C29.6446 15.7276 29.7385 14.7206 29.6207 13.7274C29.5028 12.7341 29.176 11.7771 28.6616 10.9192C28.1472 10.0614 27.457 9.32223 26.6364 8.75038C25.8158 8.17852 24.8833 7.78695 23.9005 7.60143C22.9176 7.4159 21.9066 7.44064 20.934 7.67401L19.0498 8.18685",
    stroke: "#19C489",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileupload);
export default __webpack_public_path__ + "static/media/fileupload.6a40a1bf67afc08940f19828619616f3.svg";
export { ForwardRef as ReactComponent };